import { EditFeatureState } from "../editFeature.reducer";
import { IPartialReducer } from "../../../core/core-redux/reduxTypes";
import Logger from "../../../common/util/Logger";
import { isGeometryCollection } from "../../../core/geo/assertions";
import { mapFeatureToCollection } from "../../../core/geo/geometryMapper";
import { GeometryTypes } from "../../../common/constants/GeometryTypes";
import { LineSegment, LineSegmentType } from "../../../core/geo/types";

const logger = new Logger("insertFeaturePartialReducer");

export const insertFeaturePartialReducer: IPartialReducer<EditFeatureState> = (state, action) => {
    const feature = action.feature;
    if (isGeometryCollection(feature.geometry)) {
        logger.info(`inserting feature ${feature.properties.id} coordinates: ${feature.geometry}`);
    } else {
        logger.info(`inserting feature ${feature.properties.id} coordinates: ${feature.geometry.coordinates}`);
    }
    const stateFeature = state.editedFeatures?.features[0]!;
    const segments: LineSegment[] = [];
    if (feature.geometry.type === GeometryTypes.POLYGON || feature.geometry.type === GeometryTypes.LINE) {
        const coordinates =
            feature.geometry.type === GeometryTypes.POLYGON
                ? feature.geometry.coordinates[0].slice(0, -1)
                : feature.geometry.coordinates;

        // TODO ICH -> MSA: reducer should not know about any linesegment, its just persistent layer
        for (let i = 0; i < coordinates.length; i++) {
            segments.push({
                type: LineSegmentType.GREAT_CIRCLE,
                properties: {
                    index: i,
                    point: coordinates[i],
                    length: 0,
                    modifiedIndex: i,
                },
            });
        }
    }

    const updatedFeature = {
        ...stateFeature,
        geometry: feature.geometry,
        properties: {
            ...stateFeature.properties,
            segments: segments,
            radius: feature.properties.radius,
        },
    };

    return {
        ...state,
        editedFeatures: mapFeatureToCollection(updatedFeature),
        newFeature: false,
    };
};
